




















import Vue from 'vue';
import { IFilterValue } from '../store/state';

interface ITagValueProps extends IFilterValue {
	displayName: string;
}

export default Vue.extend<{}, {}, {}, ITagValueProps>({
	props: {
		name: String,
		value: String,
		selected: Boolean,
		displayName: String
	}
})
